"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SplitFactory = void 0;
var factory_1 = require("./factory");
Object.defineProperty(exports, "SplitFactory", { enumerable: true, get: function () { return factory_1.SplitFactory; } });
